'use strict';

var $d = require('../dependency');
var plugins = require('../plugins');

var _ = $d._;
var TIME_LIMIT = 120 * 1000;

/**
 * The require module return object.
 */
exports.flow = flow;
exports.trigger = trigger;

/**
 * [flow the function to create the tasks execution train.]
 * @param  {array} tasks  [the array of the tasks; each task includes the plugin function and config.]
 * @param  {object} context [the params for the initial promise to execute.]
 * @return {promise}        [promise for the complete task execution to complete.]
 */
function flow(tasks, context) {
    /**
     * Use the lodash reduce function to execute the tasks chain .
     */
    var promise = _.reduce(
        tasks,
        function (promise, task) {
            return executeSingleTask(promise, task, context);
        },
        Promise.resolve()
    );


    // promise = promise.then(function(err) {
    //     console.err(err);
    // });

    return promise;
}

/**
 * [trigger the function to trigger execution of the task chain.Can be used is callback is passed
 * which will be called after the execution of the task chain.]
 * @param  {array} tasks  [the array of the tasks; each task includes the plugin function and config.]
 * @param  {object} context [the params for the initial promise to execute.]
 * @param  {function} after  [the callback function to be called after the task chain completes.]
 * @return {undefined}
 */
function trigger(tasks, context, successFn, failFn) {
    successFn = successFn || _.noop;
    failFn = failFn || _.noop;
    flow(tasks, context).then(
        function () {
            successFn(context);
        },
        function (err) {
            failFn(err);
        }
    );
}

/**
 * [executeSingleTask given a task, create a promise to execute the task.]
 * @param  {promise} promise [the previous tasks promise]
 * @param  {object} task    [the task descriptor contains the function and other config for the function.]
 * @return {promise}         [the promise for executing the current task ]
 */
function executeSingleTask(promise, task, context) {
    var fn, name, config;
    if (_.isString(task) && plugins[task]) {
        name = task;
        fn = plugins[task];
        config = {};
    }
    else if (_.isString(task.name) && plugins[task.name]) {
        fn = plugins[task.name];
        config = task.config ? task.config : {};
        name = task.name;
    } else if (_.isFunction(task.plugin)) {
        fn = task.plugin;
        config = task.config ? task.config : {};

        name = fn.name ? '<' + fn.name + '>' : '<anonymous>';
    } else {
        throw 'We don\'t know how to handle this task';
    }

    promise = promise.then(function () {
        return forgePromise(name, fn, context, config);
    });

    return promise;
}

/**
 * [forgePromise create a new promise object to handle the executino of the given task and handle its resolve ,reject and previous
 * promise resolved/rejected object.Also logging the execution success failure is done.]
 * @param  {string}   name   [the name of the task to execute.]
 * @param  {Function} fn     [the task function.]
 * @param  {object}   context [the base context object ; initial input of the function.]
 * @param  {object}   params [the response resolved/rejected of ther previous promise object.]
 * @return {promise}          [the generated promise]
 */
function forgePromise(name, fn, context, config) {
    return new Promise(function (resolve, reject) {
        var timer = _.delay(
            function () {
                reject(getTimeoutError(name));
            },
            TIME_LIMIT
        ),
            next = getTimerProxy(timer, [log, decide]);
        _mxcLogger.log('Working on ' + name);
        fn(context, config, next);

        function decide(err) {
            if (err) {
                _.defer(reject, err);
            } else {
                _.defer(resolve, context);
            }
        }
    });

    function log(err) {
        if (err) {
            _mxcLogger.log(name + ' has failed', err);
        } else {
            _mxcLogger.log(name + ' is success', context);
        }
    }
}

/**
 * [getTimeoutError function to return the timeout error]
 * @param  {string} name [Name of the timed out function.]
 * @return {object}      [The error object]
 */
function getTimeoutError(name) {
    return new Error(name + ' has been timed out');
}

/**
 * [getTimerProxy description]
 * @param  {[type]} timer  [description]
 * @param  {[type]} fnList [description]
 * @return {[type]}        [description]
 */
function getTimerProxy(timer, fnList) {
    return function (arg) {
        clearTimeout(timer);
        _.each(fnList, function (fn) {
            fn(arg);
        });
    };
}


// });